import { render } from "./my-contacts.vue?vue&type=template&id=4948071a&scoped=true"
import script from "./my-contacts.vue?vue&type=script&lang=js"
export * from "./my-contacts.vue?vue&type=script&lang=js"

import "./my-contacts.vue?vue&type=style&index=0&id=4948071a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4948071a"]])

export default __exports__